module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0097.jpg?v=84eb5c3a";